import { Component, inject, Input } from '@angular/core';
import { Toast, ToastService, ToastType } from '@app-core';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-toast',
    standalone: true,
    imports: [NgbToastModule],
    templateUrl: './toast.component.html',
    styleUrl: './toast.component.scss',
    host: {
        '[class]': 'toastClass',
        style: 'z-index: 1200;',
    },
})
export class ToastComponent {
    toastService = inject(ToastService);
    @Input() toastClass: string = 'toast-container position-fixed top-0 end-0 ps-3 pt-2 pe-3 pb-3';
    hidden = false;

    close(toast: Toast) {
        this.toastService.remove(toast);
    }

    iconClass(toast: Toast): string | undefined {
        if (toast) {
            const classes = ['bi'];
            const iconTypeClass = {
                [ToastType.success]: 'bi-check-circle',
                [ToastType.danger]: 'bi-exclamation-circle',
                [ToastType.info]: 'bi-info-circle',
                [ToastType.warning]: 'bi-exclamation-triangle',
                [ToastType.primary]: 'bi-info-circle',
                [ToastType.secondary]: 'bi-info-circle',
            };

            classes.push(iconTypeClass[toast.toastType]);
            return classes.join(' ');
        }
        return '';
    }

    styleClass(toast: Toast): string | undefined {
        if (toast) {
            const classes = ['toast'];
            const toastTypeClass = {
                [ToastType.success]: 'bg-success text-light',
                [ToastType.danger]: 'bg-danger text-light',
                [ToastType.info]: 'bg-info text-light',
                [ToastType.warning]: 'bg-warning text-dark',
                [ToastType.primary]: 'bg-primary text-light',
                [ToastType.secondary]: 'bg-secondary text-light',
            };

            classes.push(toastTypeClass[toast.toastType]);
            return classes.join(' ');
        }
        return '';
    }
}
